// This is only for use a a placeholder for the [] control character which creates an empty cell
// The grid cell component is the displayComponents folder
import type { ReactElement } from "react";
import { memo } from "react";
import styled from "styled-components";
import type { ElementProps } from "../../functionalComponents/RenderPage";

const StyledCell = styled.div``;

const Cell = (): ReactElement<ElementProps> => <StyledCell className="cell" />;

export default memo(Cell);
